<template>
  <div class="d-flex flex-column align-center justify-center h-100 w-100 py-6">
    <div v-if="false" class="d-flex align-center mb-3 mt-4">
      <v-card color="primary" class="mr-3">
        <v-img height="32" width="32" :src="brandIconWhite" />
      </v-card>
      <div class="text-h4">Schedule Event</div>
    </div>
    <v-progress-circular v-show="loader" indeterminate size="30" width="2" color="primary" />
    <!-- Mount only after the client id is resolved — the component errors
         ("sessionId is required") if it boots without slug + clientId -->
    <nylas-scheduling v-if="resolvedClientId" v-show="!loader" />
  </div>
</template>

<script>
import '../../node_modules/@nylas/web-elements/dist/nylas-web-elements/nylas-web-elements.esm.js'

import brandIconWhite from '@/assets/img/brand/Symbo_Icon_White.svg'

const NYLAS_API_URL = process.env.VUE_APP_NYLAS_API_URL || 'https://api.us.nylas.com'

export default {
  data: () => ({
    brandIconWhite,
    loader: false,
    resolvedClientId: null,
  }),
  methods: {
    // Booking links embed the client id of the Nylas app the page lived in
    // when the link was generated. After a mailbox migrates to another app
    // its pages are copied there (same slug), so links sent earlier point at
    // the old app — where the config is gone or its grant is dead. Try the
    // URL's client id first; if that config isn't bookable, fall back to the
    // other configured app ids for the same slug.
    candidateClientIds(urlClientId) {
      const configured = (process.env.VUE_APP_NYLAS_APP_IDS || process.env.VUE_APP_NYLAS_APP_ID || '')
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean)
      return [urlClientId, ...configured.filter((id) => id !== urlClientId)]
    },
    async resolveClientId(urlClientId, slug) {
      const candidates = this.candidateClientIds(urlClientId)
      for (const clientId of candidates) {
        if (await this.isBookableConfig(clientId, slug)) return clientId
      }
      // Nothing verified as bookable — keep the URL's id (original behavior)
      return urlClientId
    },
    async isBookableConfig(clientId, slug) {
      try {
        // Config exists in this app?
        const settings = await this.fetchWithTimeout(
          `${NYLAS_API_URL}/v3/scheduling/ui-settings?client_id=${clientId}&slug=${slug}`
        )
        if (!settings.ok) return false
        // Availability resolves? A config left behind in an old app still
        // "exists" but 400s here because its grant is dead
        const start = Math.floor(Date.now() / 1000)
        const end = start + 14 * 24 * 3600
        const availability = await this.fetchWithTimeout(
          `${NYLAS_API_URL}/v3/scheduling/availability?start_time=${start}&end_time=${end}&client_id=${clientId}&slug=${slug}`
        )
        return availability.ok
      } catch (e) {
        return false
      }
    },
    fetchWithTimeout(url) {
      const controller = new AbortController()
      const timer = setTimeout(() => controller.abort(), 5000)
      return fetch(url, { signal: controller.signal }).finally(() => clearTimeout(timer))
    },
    openSchedulingPage() {
      const nylasScheduling = document?.querySelector('nylas-scheduling')
      if (!nylasScheduling) return

      const startTime = this.$route.query.start
      const endTime = this.$route.query.end
      const email = this.$route.query.email?.replaceAll('%40', '@')
      const name = this.$route.query.name?.replaceAll('%20', ' ')

      const defaultSchedulerState = {
        nylasBranding: false,
      }
      if (startTime && endTime) {
        defaultSchedulerState.showBookingForm = true
        defaultSchedulerState.selectedTimeslot = {
          start_time: new Date(parseInt(this.$route.query?.start)),
          end_time: new Date(parseInt(this.$route.query?.end)),
        }
        nylasScheduling.classList = ['no-back']
      }

      if (email || name)
        nylasScheduling.bookingInfo = {
          primaryParticipant: {
            email,
            name,
          },
        }

      nylasScheduling.defaultSchedulerState = defaultSchedulerState
      nylasScheduling.nylasBranding = false
      nylasScheduling.clientId = this.resolvedClientId
      nylasScheduling.slug = this.$route.params.slug

      setTimeout(() => {
        const form = nylasScheduling?.shadowRoot?.querySelector('nylas-booking-form')
        form?.shadowRoot
        if (form) {
          var styleOverrides = document.createElement('style')
          styleOverrides.innerHTML = `
              .cta { display: flex !important; }
            `
          form?.shadowRoot?.appendChild(styleOverrides)
        }
      }, 400)
      setTimeout(() => (this.loader = false), 2000)
    },
  },

  async mounted() {
    document.title = 'Book Meeting'
    this.loader = true
    // Resolve which app serves this link BEFORE mounting the component —
    // it must receive slug + clientId at boot
    this.resolvedClientId = await this.resolveClientId(
      this.$route.params.id,
      this.$route.params.slug
    )
    this.$nextTick(() => {
      this.openSchedulingPage()
    })
  },
}
</script>
